(function ($) {
  const initializeBlock = function ($block) {
    const $timeline = $block.find(".timeline-slides");
    if ($timeline.hasClass("slick-initialized")) {
      $timeline.slick("unslick");
    }

    $timeline.slick({
      infinite: true,
      arrows: false,
      dots: false,
      speed: 500,
      autoheight: true,
      autoplay: false,
      autoplaySpeed: 5000,
      slidesToShow: 1,
      cssEase: "cubic-bezier(0.7, 0, 0.3, 1)",
      fade: true,
    });

    // Enable autoplay when the block is in view
    $block.waypoint({
      handler: function (direction) {
        if (direction === "down") {
          $timeline.slick("slickPlay");
        } else {
          $timeline.slick("slickPause");
        }
      },
      offset: "50%",
    });

    // Add active class to the first .timeline__year
    $block.find(".timeline__years .timeline__year").first().addClass("active");

    $timeline.on(
      "beforeChange",
      function (event, slick, currentSlide, nextSlide) {
        // Scan .timeline__years from the same block
        const $years = $block.find(".timeline__years");

        $years.find(".timeline__year").removeClass("active");

        // Add class to .timeline__year under .timeline__years with data-year less than or equal to nextSlide
        $years.find(".timeline__year").each(function () {
          const $this = $(this);
          const year = $this.data("year");
          if (year <= nextSlide) {
            $this.addClass("active");
          }
        });
      }
    );

    $block.find(".timeline__year").on("click", function () {
      const $this = $(this);
      const year = $this.data("year");
      $timeline.slick("slickGoTo", year);
    });
  };

  $(document).ready(function () {
    $(".block--timeline").each(function () {
      initializeBlock($(this));
    });
  });

  if (window.acf) {
    window.acf.addAction("render_block_preview/type=timeline", initializeBlock);
  }
})(jQuery);
